import SectionHeading from "@/pages/home/components/SectionHeading";
import { nightSlots } from "@/mocks/content";

export default function NightSlot() {
  return (
    <section id="night" className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="深夜档看点差异"
          title="22:00 之后，平台会换一套编排"
          desc="深夜档不是简单地把白天内容延长，而是独立安排。分区热度、内容类型和开放范围都会变化，下面按时间梳理各阶段的差异。"
        />

        <div className="mt-10 md:mt-14 relative">
          <div className="hidden lg:block absolute top-[46px] left-0 right-0 h-px bg-background-300"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {nightSlots.map((s) => (
              <article
                key={s.time}
                className={`relative rounded-lg border p-5 md:p-6 ${
                  s.featured
                    ? "bg-foreground-950 border-foreground-950"
                    : "bg-background-50 border-background-200/80"
                }`}
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`w-9 h-9 flex items-center justify-center rounded-full text-sm ${
                      s.featured ? "bg-accent-500 text-foreground-950" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={s.time === "22:00" ? "ri-sun-line" : "ri-moon-line"}></i>
                  </span>
                  <span className={`font-heading font-bold text-xl ${s.featured ? "text-background-50" : "text-foreground-950"}`}>
                    {s.time}
                  </span>
                </div>
                <h3 className={`mt-4 font-heading font-bold text-base ${s.featured ? "text-background-50" : "text-foreground-950"}`}>
                  {s.title}
                </h3>
                <p className={`mt-2 text-sm leading-relaxed ${s.featured ? "text-background-200" : "text-foreground-600"}`}>
                  {s.desc}
                </p>
                {s.featured && (
                  <span className="mt-4 inline-flex items-center gap-1 text-[11px] text-accent-300 bg-white/10 px-2 py-1 rounded-full">
                    <i className="ri-vip-crown-line"></i>
                    深夜重点时段
                  </span>
                )}
              </article>
            ))}
          </div>
        </div>

        <div className="mt-6 md:mt-8 rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            <strong className="text-foreground-950">一句话总结：</strong>
            深夜档的分区分布与白天相反，情感陪伴与轻音陪伴类内容权重上升，且部分范围只对更高权限开放。
          </p>
          <a
            href="#vip"
            className="shrink-0 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 cursor-pointer transition-colors"
          >
            <i className="ri-vip-crown-line"></i>
            查看权限差异
          </a>
        </div>
      </div>
    </section>
  );
}